var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        {
            'app-desktop': !this.isTouch
        }
    ],attrs:{"id":"app"}},[(!['Login', 'Start'].includes(_vm.$route.name))?_c('Header'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }